import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {colorFunctions} from "../../constants/colors";
import {useHistory} from 'react-router-dom';
import backgroundImage from "../../../images/nationwidebackground.png";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import omniscanLogo from "../../../images/omniscanlogo.png";
import HomeBoxProperties from "../home/components/HomeBoxProperties";
import HomeBoxUtilisation from "../home/components/HomeBoxUtilisation";
import HomeBoxSpace from "../home/components/HomeBoxSpace";
import HomeBoxDocuments from "../home/components/HomeBoxDocuments";
import HomeBoxLeases from "../home/components/HomeBoxLeases";
import HomeBoxProjects from "../home/components/HomeBoxProjects";
import HomeBoxHelpDesk from "../home/components/HomeBoxHelpDesk";
import HomeBoxTasks from "../home/components/HomeBoxTasks";
import {COLOR_FOCUS} from "../../constants/general-constants";
import {COLOR_EDIT} from "../../constants/general-constants";
import {COLOR_MEETING} from "../../constants/general-constants";
import {COLOR_ALTERNATIVE} from "../../constants/general-constants";
import {COLOR_SOCIAL} from "../../constants/general-constants";
import {SYSTEM_BLUE_BACKGROUND} from "../../constants/general-constants";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../../constants/general-constants";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../constants/general-constants";

import {OMNISCAN_CORPORATE_RED_RGB} from "../../constants/colors";
import {OMNISCAN_CORPORATE_GREEN_RGB} from "../../constants/colors";
import {OMNISCAN_CORPORATE_PURPLE_RGB} from "../../constants/colors";


export default function HomeBlue(){
	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const history = useHistory();
	
	const defaultBorderColor = "rgba(255, 255, 255, 0.6)";
	const searchId = useRef(null);
	
	const [thisBackground, setThisBackground] = useState("");
	const [thisRed, setThisRed] = useState("");
	const [lightBlue, setLightBlue] = useState("");
	const [locations, setLocations] = useState([]);
	const [likeString, setLikeString] = useState("");
	const [posLeft, setPosLeft] = useState("0");
	const [posTop, setPosTop] = useState("0");
	const [displayResults, setDisplayResults] = useState("none");
	const [thisGradient, setThisGradient] = useState("");
	const [clientLogo, setClientLogo] = useState("");
	

	useEffect(() => {
		setThisBackground(colorFunctions.getPrimaryColor());
		setThisRed(colorFunctions.getPrimaryAlternative());
		setPosLeft(searchId.current.getBoundingClientRect().left);
		setPosTop(searchId.current.getBoundingClientRect().top + 52);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/getclient", null, setColors);
	}, []);
	
	
	const setColors = (client) => {
		let logoSource = client.resourceFolderUrl + "/client_logo.png";
			functions.getFileSource(logoSource,
				setClientLogo, null);
		sessionStorage.setItem("colorPrimary", client.colorPrimary);
		sessionStorage.setItem("colorSecondary", client.colorSecondary);
		sessionStorage.setItem("colorGradient", client.colorGradient);
		setThisGradient(client.colorGradient);
	};
	
	useEffect(() => {
		
		if(likeString.length > 3){
			functions.getObjectFromAjax("/resolutionsoftwareplatform/facilitieslike?like=" + likeString, setLocations, null);
			setDisplayResults("flex");
		}
		else{
			setLocations([]);
			setDisplayResults("none");
		}
		
	}, [likeString]);

	
	const goDashboardLease = () => {
  	history.push('/dashboardlease');
  };
  
  const goDashboardUtilisation = () => {
  	history.push('/utilistion');
  };
  
  const resultsContainer = {
  	display:displayResults,
  	position:"fixed",
  	left:posLeft,
  	top:posTop,
  	width:"800px",
  	backgroundColor:"#223",
  	minHeight:"100px",
  	flexDirection:"column"
  };
  
  const resultsRow = {
  	display:"flex",
  	width:"100%",
  	height:"40px",
  	borderBottom:"1px solid grey",
  	alignItems:"center",
  	cursor:"pointer"
  };
  
  const resultsIcon = {
  	display:"flex",
  	width:"15px",
  	height:"15px",
  	margin:"10px",
  	color:"white"
  };
  
  const resultsText = {
  	display:"flex",
  	fontSize:"14px",
  	color:"white"
  };
  
  const goBuilding = (id) => {
  	history.push('/facility/' + id);
  };
  
  const resultsDisplay = locations.map((item, index) => 
  	<div style={resultsRow} onClick={() => {goBuilding(item.id)}}>
  		<FontAwesomeIcon icon="arrow-right" style={resultsIcon}/>
  		<div style={resultsText}>
  			{item.name}
  		</div>
  	</div>
  );
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	backgroundColor:SYSTEM_BLUE_BACKGROUND,
  	backgroundSize:"100% 100%"
  };
  
  
  const header = {
  	display:'flex',
  	width:"100%",
  	justifyContent:"space-between"
  };
  
  const logoStyle = {
  	display:"flex",
  	maxHeight:"60px",
  	marginLeft:"12px",
  	marginTop:"12px"
  };
  
  const footer = {
		position:"fixed",
		display:"flex",
		right:"0px",
		bottom:"0px",
		padding:"20px",
		paddingTop:"10px",
		paddingBottom:"10px",
		alignItems:"center",
		backgroundColor:"white",
		borderTopLeftRadius:"20px"
	};
	
	const omniscanLogoStyle = {
		display:"flex",
		width:"230px",
		marginLeft:"50px",
		marginRight:"50px",
		marginTop:"2px"
	};
	
	const omniscan = {
		display:'flex',
		fontSize:"21px",
		color:'black'
	};
	
	const by = {
		display:'flex',
		fontSize:"21px",
		color:'black',
		marginLeft:"10px",
		marginRight:"10px"
	};
	
	const pro = {
		display:'flex',
		fontSize:"21px",
		color:thisRed,
		
	};
	
	const handleChange = (e) => {
		setLikeString(e.target.value);
		console.log("Locations");
		console.log(locations);
	};
	
	const topRight = {
		display:"flex"
	};
	
	const searchPanel = {
		display:'flex',
		width:"800px",
		backgroundColor:"rgba(0,0,0,0)",
		borderRadius:"6px",
		marginLeft:"20px",
		marginTop:"20px",
		marginRight:"0px",
		height:"50px",
		justifyContent:"space-between",
		alignItems:"center",
		border:"1px solid rgba(255,255,255,0.2)",
	};
	
	const iconStyle = {
		display:"flex",
		width:"20px",
		height:"20px",
		color:"white",
		marginLeft:"20px"
	};
	
	const searchButton = {
		display:"flex",
		width:"100px",
		marginRight:"10px",
		//border:"1px solid white",
		alignItems:"center",
		color:"white",
		fontSize:"14px",
		justifyContent:"space-around",
		cursor:"pointer",
		backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		height:"30px",
		borderRadius:"6px"
	};
	
	const searchInput = {
		display:"flex",
		color:"white",
		fontSize:"21px",
		paddingLeft:"10px",
		marginLeft:"20px",
		marginRight:"20px",
		flexGrow:"1",
		height:"40px",
		backgroundColor:"rgba(0,0,0,0)",
		border:"0px"
	};
	
	const helpIconContainer = {
		display:"flex",
		width:"50px",
		height:"50px",
		borderRadius:"25px",
		backgroundColor:"white",
		margin:"20px",
		cursor:'pointer',
		alignItems:"center",
		justifyContent:"space-around"
	};
	
	const helpIcon = {
		display:"flex",
		width:"30px",
		height:"30px",
		color:COLOR_GRAY_BANNER_BACKGROUND
	}
	
	const mainContent = {
		display:'flex',
  	width:"calc(100% - 40px)",
  	justifyContent:"space-between",
  	marginLeft:"20px",
  	overflow:"auto",
  	marginTop:"0px",
  	marginBottom:"20px"
	};
	
	const contentColumn = {
		display:'flex',
		width:"calc(33% - 15px)",
		flexDirection:"column",
		
		borderRadius:"10px"	
	};
	
	const headerComponent = {
		display:"flex",
		border:"1px solid rgba(255,255,255,0.2)",
		borderRadius:"10px",
		//borderTopRightRadius:"10px",
		minHeight:"60px",
		alignItems:"center",
		width:"calc(100% - 2px)",
		backgroundColor:"rgba(0,0,0,0.2)",
		marginBottom:"15px"
	};
	
	const headerIcon = {
		display:"flex",
		width:"30px",
		height:"30px",
		color:"white",
		marginLeft:"20px"
	};
	
	const headerTitle = {
		display:"flex",
		color:"white",
		fontSize:"16px",
		marginLeft:"20px",
		fontWeight:"bold"
	};
	
	const goTimetable = () => {
		const host = window.location.hostname;
		if(host === "localhost" || host === "universityofleeds.omniscanpro.cloud"){
			history.push('/timetabledashboard');
		}
	};
	
	return (
			<div style={thisContainer}>
				<div style={header}>
					<img src={clientLogo} style={logoStyle}/>
					<div style={topRight}>
						<div style={searchPanel} ref={searchId}>
							<FontAwesomeIcon icon="search" style={iconStyle}/>
							<input type="text" onChange={handleChange} style={searchInput}/>
							<div style={searchButton}>
								Search
							</div>
						</div>
						<div style={helpIconContainer} onClick={goTimetable}>
							<FontAwesomeIcon icon="info" style={helpIcon}/>
						</div>
					</div>
				</div>
				
				<div style={mainContent}>
					<div style={contentColumn}>
						<div style={{...headerComponent, backgroundColor:'rgba(' + OMNISCAN_CORPORATE_RED_RGB + ', 0.8)'}}>
							<FontAwesomeIcon icon="chart-bar" style={headerIcon}/>
							<div style={headerTitle}>
								Data
							</div>
						</div>
						<HomeBoxProperties/>
						<HomeBoxSpace/>
						<HomeBoxUtilisation/>
					</div>
					<div style={contentColumn}>
						<div style={{...headerComponent, backgroundColor:'rgba(' + OMNISCAN_CORPORATE_GREEN_RGB + ', 0.8)'}}>
							<FontAwesomeIcon icon="file" style={headerIcon}/>
							<div style={headerTitle}>
								Documents
							</div>
						</div>
						<HomeBoxDocuments/>
						<HomeBoxLeases/>
					</div>
					<div style={contentColumn}>
						<div style={{...headerComponent, backgroundColor:'rgba(' + OMNISCAN_CORPORATE_PURPLE_RGB + ', 0.8)'}}>
							<FontAwesomeIcon icon="traffic-light" style={headerIcon}/>
							<div style={headerTitle}>
								Delivery
							</div>
						</div>
						<HomeBoxTasks/>
						<HomeBoxProjects/>
						<HomeBoxHelpDesk/>
					</div>
				</div>			
	
			
				<div style={footer}>
					
					<img src={omniscanLogo} style={omniscanLogoStyle}/>
					
				</div>
				<div style={resultsContainer}>
					{resultsDisplay}
				</div>
			</div>
	);
}